import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'btn-cell-renderer',
    template: `
      <button (click)="onDuplicateBtn($event)" [disabled]="this.datesComparision()">{{this.label}}</button>
    `,
    standalone: false
})
  export class FrtRatesBidcyclesDuplicateButtonRendererComponent implements ICellRendererAngularComp {
    refresh(params?: any): boolean {
      return true;
    }
    private params: any;
    label: string;
  
    agInit(params: any): void {
      this.params = params;
      this.label = this.params.label;
    }

    datesComparision(){
      if((new Date()) > new Date(this.params.data.bidWindowCloseDate)) return false;
      else return true;
    }
  
    onDuplicateBtn($event) {
      this.params.onClick(this.params.data);
    }
  }